import {Component, Input} from '@angular/core';
import {MetricCard} from '@gatewee/types/system';

@Component({
  selector: 'gatewee-metric-card',
  templateUrl: './metric-card.component.html',
  styleUrls: ['./metric-card.component.css'],
  standalone: false,
})
export class MetricCardComponent {
  @Input() cards!: MetricCard[];
  @Input() loading = false;

  readonly skeletonItems = [0, 1, 2];

  get isLoading(): boolean {
    return !this.cards;
  }
}
